(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-simulator"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  if (window.__hsxReady) { window.__hsxBoot(); return; }
  window.__hsxReady = true;

  var NS = 'http://www.w3.org/2000/svg', AGE_MAX = 100, RISE_K = 4.5;

  function svgEl(tag, attrs, text) {
    var e = document.createElementNS(NS, tag), k;
    for (k in attrs) if (attrs.hasOwnProperty(k)) e.setAttribute(k, attrs[k]);
    if (text != null) e.textContent = text;
    return e;
  }

  function init(root) {
    var q = function (n) { return root.querySelector('[data-hsx="' + n + '"]'); };

    var cfgNode = q('config');
    var cfg;
    try { cfg = JSON.parse(cfgNode.textContent); } catch (err) { return; }

    var LEVERS = (cfg.levers || []).filter(function (l) { return l.d && l.d.length; });
    if (!LEVERS.length) return;

    var M = cfg.model;
    var PEAK = M.peak, GOOD_T = M.goodT, FAIR_T = M.fairT, BASE_V = M.baseline;
    var N_MIN = 1.39, N_MAX = M.nMax;

    var W_SUM = LEVERS.reduce(function (a, l) { return a + l.w; }, 0);

    function composite(v) {
      var s = 0;
      for (var i = 0; i < LEVERS.length; i++) s += LEVERS[i].w * (v[LEVERS[i].id] / 100);
      return s / W_SUM;
    }
    function solve(S) {
      var L = M.lifeFloor + (M.lifeCeiling - M.lifeFloor) * S;
      var n = N_MIN + (N_MAX - N_MIN) * Math.pow(S, 1.735);
      return { S:S, L:L, n:n,
               hs: PEAK + (L - PEAK) * Math.pow(1 - Math.pow(GOOD_T, n), 1 / n) };
    }
    function qol(age, L, n) {
      if (age <= 0) return 0;
      if (age <= PEAK) return 1 - Math.pow(1 - age / PEAK, RISE_K);
      var x = (age - PEAK) / (L - PEAK);
      if (x >= 1) return 0;
      return Math.pow(1 - Math.pow(x, n), 1 / n);
    }

    var vals = {}, baseVals = {}, i;
    for (i = 0; i < LEVERS.length; i++) {
      vals[LEVERS[i].id] = M.start;
      baseVals[LEVERS[i].id] = BASE_V;
    }
    var BASE   = solve(composite(baseVals));
    var target = solve(composite(vals));
    var shown  = { S:target.S, L:target.L, n:target.n, hs:target.hs };

    /* ---------------- lever panel ---------------- */
    var host = q('levers'), html = '', lastG = null, worthEls = {}, descEls = {}, inputs = {};
    for (i = 0; i < LEVERS.length; i++) {
      var l = LEVERS[i];
      if (l.g !== lastG) {
        if (lastG !== null) html += '</div></div>';
        html += '<div class="hsx-group"><div class="hsx-group-k">' + esc(l.g) +
                '</div><div class="hsx-group-items">';
        lastG = l.g;
      }
      html +=
        '<div class="hsx-lever">' +
          '<div class="hsx-lever-top">' +
            '<label class="hsx-lever-name" for="hsxr-' + l.id + '">' + esc(l.name) + '</label>' +
            '<span class="hsx-lever-worth" data-worth="' + l.id + '">&mdash;</span>' +
          '</div>' +
          '<input type="range" min="0" max="100" step="1" value="' + M.start + '" ' +
            'id="hsxr-' + l.id + '" data-id="' + l.id + '" ' +
            'aria-label="' + esc(l.name) + '" style="--hsx-fill:' + M.start + '%">' +
          '<div class="hsx-lever-desc" data-desc="' + l.id + '"></div>' +
        '</div>';
    }
    html += '</div></div>';
    host.innerHTML = html;

    for (i = 0; i < LEVERS.length; i++) {
      var id = LEVERS[i].id;
      worthEls[id] = host.querySelector('[data-worth="' + id + '"]');
      descEls[id]  = host.querySelector('[data-desc="' + id + '"]');
      inputs[id]   = host.querySelector('#hsxr-' + id);
    }

    host.addEventListener('input', function (e) {
      var id = e.target.getAttribute('data-id');
      if (!id) return;
      vals[id] = +e.target.value;
      e.target.style.setProperty('--hsx-fill', e.target.value + '%');
      recompute();
    });

    var presets = root.querySelectorAll('[data-preset]');
    for (i = 0; i < presets.length; i++) {
      presets[i].addEventListener('click', function (e) {
        var v = +e.currentTarget.getAttribute('data-preset'), j;
        for (j = 0; j < LEVERS.length; j++) {
          var pid = LEVERS[j].id;
          vals[pid] = v;
          inputs[pid].value = v;
          inputs[pid].style.setProperty('--hsx-fill', v + '%');
        }
        recompute();
      });
    }

    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }

    /* ---------------- recompute ---------------- */
    function recompute() {
      target = solve(composite(vals));
      for (var i = 0; i < LEVERS.length; i++) {
        var l = LEVERS[i], d = l.d;
        descEls[l.id].textContent = d[Math.min(d.length - 1, Math.floor(vals[l.id] / 100 * d.length))];

        var alt = {}, k;
        for (k in vals) if (vals.hasOwnProperty(k)) alt[k] = vals[k];
        alt[l.id] = BASE_V;
        var worth = target.hs - solve(composite(alt)).hs;
        worthEls[l.id].textContent =
          (worth >= 0.05 ? '+' : worth <= -0.05 ? '' : '±') + worth.toFixed(1) + ' yrs';
        worthEls[l.id].className = 'hsx-lever-worth' + (worth >= 0.05 ? ' is-on' : '');
      }
      tick();
    }

    /* ---------------- tween ---------------- */
    var raf = null,
        reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function tick() {
      if (raf) return;
      raf = requestAnimationFrame(function step() {
        raf = null;
        var e = reduce ? 1 : 0.18, done = true, k;
        for (k in target) if (target.hasOwnProperty(k)) {
          var d = target[k] - shown[k];
          if (Math.abs(d) > 0.0004) { shown[k] += d * e; done = false; }
          else shown[k] = target[k];
        }
        draw();
        if (!done) raf = requestAnimationFrame(step);
      });
    }

    /* ---------------- render ---------------- */
    var svg = q('svg'), wrap = q('chart'), tip = q('tip');
    var geo = null, gStatic = null, gDyn = null, hoverAge = null;
    var uid = 'hsxFill-' + Math.random().toString(36).slice(2, 9);

    var CS = getComputedStyle(root);
    function V(n, fb) { var v = CS.getPropertyValue('--hsx-' + n).trim(); return v || fb; }
    var C_YOU = V('you','#3D5C99'), C_AVG = V('avg','#A9752F'), C_SUR = V('surface','#FCFBF5');
    var C_GRID = V('grid','#060C17'), C_MARK = V('mark','#060C17');
    var C_LABEL = V('label','#545B69'), C_TICK = V('tick','#767C88');
    var C_POS = V('pos','#4E7A63'), C_NEG = V('neg','#B0483C');
    var BANDS = [
      { lo:GOOD_T, hi:1,      c:V('good','#66917B'), label:'Good Health' },
      { lo:FAIR_T, hi:GOOD_T, c:V('fair','#D4A017'), label:'Fair Health' },
      { lo:0,      hi:FAIR_T, c:V('poor','#C1564A'), label:'Poor Health' }
    ];
    var STAGES = [
      { a:0,  b:20,  n:'Juvenile' },     { a:20, b:40,  n:'Young Adult' },
      { a:40, b:60,  n:'Mature Adult' }, { a:60, b:80,  n:'Senior' },
      { a:80, b:100, n:'Aged' }
    ];

    function layout() {
      var W = Math.max(300, wrap.clientWidth - 12);
      var narrow = W < 620, tiny = W < 430;
      var H = tiny ? 320 : narrow ? 370 : Math.round(Math.min(460, Math.max(380, W * 0.40)));
      var m = { t:54, r: narrow ? 14 : 116, b: narrow ? 44 : 56, l: tiny ? 34 : 46 };

      geo = { W:W, H:H, m:m, narrow:narrow, tiny:tiny,
              pw: W - m.l - m.r, ph: H - m.t - m.b,
              x: function (a) { return m.l + (a / AGE_MAX) * (W - m.l - m.r); },
              y: function (v) { return m.t + (1 - v) * (H - m.t - m.b); } };

      svg.setAttribute('width', W);
      svg.setAttribute('height', H);
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      gStatic = svgEl('g'); svg.appendChild(gStatic);
      gDyn    = svgEl('g'); svg.appendChild(gDyn);
      drawStatic();
      draw();
    }

    function drawStatic() {
      var g = geo, f = gStatic, i;

      var defs = svgEl('defs');
      var lg = svgEl('linearGradient', { id:uid, x1:'0', y1:'0', x2:'0', y2:'1' });
      lg.appendChild(svgEl('stop', { offset:'0%',   'stop-color':C_YOU, 'stop-opacity':'0.13' }));
      lg.appendChild(svgEl('stop', { offset:'100%', 'stop-color':C_YOU, 'stop-opacity':'0' }));
      defs.appendChild(lg); f.appendChild(defs);

      for (i = 0; i < BANDS.length; i++) {
        var b = BANDS[i], yTop = g.y(b.hi), yBot = g.y(b.lo);
        f.appendChild(svgEl('rect', { x:g.m.l, y:yTop, width:g.pw, height:yBot - yTop,
          fill:b.c, 'fill-opacity': i === 0 ? 0.13 : i === 1 ? 0.13 : 0.10 }));
        if (i > 0) f.appendChild(svgEl('line', { x1:g.m.l, x2:g.m.l + g.pw, y1:yBot, y2:yBot,
          stroke:C_GRID, 'stroke-opacity':0.14 }));
        if (!g.narrow) {
          f.appendChild(svgEl('rect', { x:g.m.l + g.pw + 14, y:yTop + 2, width:3,
            height:(yBot - yTop) - 4, rx:1.5, fill:b.c, 'fill-opacity':0.6 }));
          f.appendChild(svgEl('text', { x:g.m.l + g.pw + 25, y:(yTop + yBot) / 2 + 4,
            fill:C_LABEL, 'font-size':12.5, 'font-weight':550 }, b.label));
        } else {
          f.appendChild(svgEl('text', { x:g.m.l + 11, y:(yTop + yBot) / 2 + 3.5, fill:b.c,
            'fill-opacity':0.8, 'font-size':10, 'font-weight':650, 'letter-spacing':'0.06em' },
            b.label.split(' ')[0].toUpperCase()));
        }
      }

      [[1, '100%'], [0, '0%']].forEach(function (p) {
        f.appendChild(svgEl('text', { x:g.m.l - 9, y:g.y(p[0]) + 4, 'text-anchor':'end',
          fill:C_TICK, 'font-size':g.tiny ? 10 : 11.5, 'font-variant-numeric':'tabular-nums' }, p[1]));
      });
      if (!g.tiny) f.appendChild(svgEl('text', { x:12, y:g.m.t + g.ph / 2, fill:C_LABEL,
        'font-size':12, 'font-weight':550, 'text-anchor':'middle',
        transform:'rotate(-90 12 ' + (g.m.t + g.ph / 2) + ')' }, 'Quality of life'));

      for (i = 0; i < STAGES.length; i++) {
        var st = STAGES[i];
        if (i > 0) f.appendChild(svgEl('line', { x1:g.x(st.a), x2:g.x(st.a), y1:g.m.t,
          y2:g.m.t + g.ph, stroke:C_GRID, 'stroke-opacity':0.10 }));
        if (!g.narrow) f.appendChild(svgEl('text', { x:(g.x(st.a) + g.x(st.b)) / 2,
          y:g.m.t + g.ph + 19, 'text-anchor':'middle', fill:C_TICK,
          'font-size':11.5, 'font-weight':550 }, st.n));
      }

      var ticks = g.tiny ? [0, 40, 80] : [0, 20, 40, 60, 80, 100];
      for (i = 0; i < ticks.length; i++) {
        f.appendChild(svgEl('text', { x:g.x(ticks[i]), y:g.m.t + g.ph + (g.narrow ? 18 : 36),
          'text-anchor': ticks[i] === 0 ? 'start' : ticks[i] === 100 ? 'end' : 'middle',
          fill:C_TICK, 'font-size':g.tiny ? 10 : 11,
          'font-variant-numeric':'tabular-nums' }, ticks[i]));
      }
      f.appendChild(svgEl('text', { x:g.m.l + g.pw / 2, y:g.H - 6, 'text-anchor':'middle',
        fill:C_LABEL, 'font-size':g.tiny ? 10.5 : 12, 'font-weight':550 }, 'Age'));
      f.appendChild(svgEl('rect', { x:g.m.l, y:g.m.t, width:g.pw, height:g.ph, fill:'none',
        stroke:C_GRID, 'stroke-opacity':0.20 }));
    }

    function pathFor(L, n, close) {
      var g = geo, d = '', first = true;
      for (var a = 0; a <= L; a += 0.5) {
        d += (first ? 'M' : 'L') + g.x(a).toFixed(2) + ' ' + g.y(qol(a, L, n)).toFixed(2);
        first = false;
      }
      d += 'L' + g.x(L).toFixed(2) + ' ' + g.y(0).toFixed(2);
      if (close) d += 'L' + g.x(0).toFixed(2) + ' ' + g.y(0).toFixed(2) + 'Z';
      return d;
    }

    function draw() {
      if (!geo) return;
      var g = geo, f = gDyn, s = shown;
      while (f.firstChild) f.removeChild(f.firstChild);

      var xHs = g.x(s.hs), xL = g.x(s.L), yGood = g.y(GOOD_T), y0 = g.y(0);

      f.appendChild(svgEl('rect', { x:xHs, y:g.m.t, width:Math.max(0, xL - xHs),
        height:g.ph, fill:V('poor','#C1564A'), 'fill-opacity':0.13 }));
      f.appendChild(svgEl('path', { d:pathFor(s.L, s.n, true), fill:'url(#' + uid + ')' }));
      f.appendChild(svgEl('path', { d:pathFor(BASE.L, BASE.n, false), fill:'none',
        stroke:C_AVG, 'stroke-width':2, 'stroke-dasharray':'6 5',
        'stroke-opacity':0.9, 'stroke-linecap':'round' }));

      var yd = pathFor(s.L, s.n, false);
      f.appendChild(svgEl('path', { d:yd, fill:'none', stroke:C_YOU, 'stroke-width':8,
        'stroke-opacity':0.11, 'stroke-linecap':'round' }));
      f.appendChild(svgEl('path', { d:yd, fill:'none', stroke:C_YOU, 'stroke-width':2.6,
        'stroke-linecap':'round' }));

      [[xHs, C_YOU], [xL, C_MARK]].forEach(function (p) {
        f.appendChild(svgEl('line', { x1:p[0], x2:p[0], y1:g.m.t - 6, y2:y0, stroke:p[1],
          'stroke-width':1.5, 'stroke-dasharray':'3 4', 'stroke-opacity':0.75 }));
      });

      var fs = g.tiny ? 10.5 : 12, rowA = g.m.t - 13, rowB = g.m.t - 31;
      var tHs = svgEl('text', { x:xHs - 7, y:rowA, 'text-anchor':'end', fill:C_YOU,
        'font-size':fs, 'font-weight':650, 'font-variant-numeric':'tabular-nums' },
        (g.tiny ? 'Good health to ' : 'Good health until ') + Math.round(s.hs));
      var tLs = svgEl('text', { x:xL + 7, y:rowA, 'text-anchor':'start', fill:C_LABEL,
        'font-size':fs, 'font-weight':600, 'font-variant-numeric':'tabular-nums' },
        (g.tiny ? 'Life ends ' : 'Life ends at ') + Math.round(s.L));
      f.appendChild(tHs); f.appendChild(tLs);

      nudge(tHs, 'end', xHs); nudge(tLs, 'start', xL);
      function nudge(node, anchor, ax) {
        var b = node.getBBox();
        if (b.x < 2) { node.setAttribute('x', ax + b.width + 7); }
        else if (b.x + b.width > g.W - 2) { node.setAttribute('x', ax - b.width - 7); }
        else return;
        node.setAttribute('text-anchor', anchor === 'end' ? 'start' : 'end');
      }
      var bH = tHs.getBBox(), bL = tLs.getBBox();
      if (bH.x + bH.width + 8 > bL.x && bL.x + bL.width + 8 > bH.x) tHs.setAttribute('y', rowB);

      var xBase = g.x(BASE.hs), delta = s.hs - BASE.hs, yAnn = yGood + (g.tiny ? 20 : 26);
      if (Math.abs(delta) > 0.35 && Math.abs(xHs - xBase) > 26) {
        var dir = delta > 0 ? 1 : -1;
        f.appendChild(svgEl('line', { x1:xBase, x2:xHs - dir * 7, y1:yAnn, y2:yAnn,
          stroke:C_MARK, 'stroke-opacity':0.6, 'stroke-width':1.5 }));
        f.appendChild(svgEl('path', { d:'M' + xHs + ' ' + yAnn + 'L' + (xHs - dir * 8) + ' ' +
          (yAnn - 4.5) + 'L' + (xHs - dir * 8) + ' ' + (yAnn + 4.5) + 'Z',
          fill:C_MARK, 'fill-opacity':0.6 }));
        f.appendChild(svgEl('line', { x1:xBase, x2:xBase, y1:yAnn - 5, y2:yAnn + 5,
          stroke:C_MARK, 'stroke-opacity':0.45, 'stroke-width':1.5 }));
        var txt = (delta > 0 ? '+' : '−') + Math.abs(delta).toFixed(1) +
                  (g.tiny ? ' yrs' : ' yrs of good health');
        var mid = (xBase + xHs) / 2, tw = txt.length * (g.tiny ? 5.6 : 6.4);
        f.appendChild(svgEl('rect', { x:mid - tw / 2 - 7, y:yAnn - (g.tiny ? 27 : 29),
          width:tw + 14, height:20, rx:10, fill:C_SUR, 'fill-opacity':0.96,
          stroke:C_GRID, 'stroke-opacity':0.20 }));
        f.appendChild(svgEl('text', { x:mid, y:yAnn - (g.tiny ? 13.5 : 15.5),
          'text-anchor':'middle', fill: delta > 0 ? C_POS : C_NEG,
          'font-size':g.tiny ? 10.5 : 12, 'font-weight':650 }, txt));
      }

      if (hoverAge != null) {
        var hx = g.x(hoverAge);
        f.appendChild(svgEl('line', { x1:hx, x2:hx, y1:g.m.t, y2:y0, stroke:C_GRID,
          'stroke-opacity':0.38, 'stroke-width':1 }));
        [[qol(hoverAge, s.L, s.n), C_YOU], [qol(hoverAge, BASE.L, BASE.n), C_AVG]].forEach(function (p) {
          f.appendChild(svgEl('circle', { cx:hx, cy:g.y(p[0]), r:4.5, fill:p[1],
            stroke:C_SUR, 'stroke-width':2 }));
        });
      }
      updateStats();
    }

    function updateStats() {
      var s = target;
      q('v-hs').innerHTML  = Math.round(s.hs) + '<small>yrs</small>';
      q('v-ls').innerHTML  = Math.round(s.L)  + '<small>yrs</small>';
      q('v-gap').innerHTML = (s.L - s.hs).toFixed(1) + '<small>yrs</small>';
      d(q('d-hs'),  s.hs - BASE.hs, false);
      d(q('d-ls'),  s.L  - BASE.L,  false);
      d(q('d-gap'), (s.L - s.hs) - (BASE.L - BASE.hs), true);

      function d(node, v, invert) {
        var up = invert ? v < -0.05 : v > 0.05, dn = invert ? v > 0.05 : v < -0.05;
        node.className = 'hsx-delta' + (up ? ' hsx-up' : dn ? ' hsx-down' : '');
        node.innerHTML = Math.abs(v) < 0.05
          ? '<span class="hsx-lg">same as average</span><span class="hsx-sm">= average</span>'
          : '<b>' + (v > 0 ? '+' : '−') + Math.abs(v).toFixed(1) + '</b> ' +
            '<span class="hsx-lg">vs. average</span><span class="hsx-sm">vs avg</span>';
      }
    }

    /* ---------------- hover ---------------- */
    function onMove(e) {
      if (!geo) return;
      var r = wrap.getBoundingClientRect();
      var px = (e.touches ? e.touches[0].clientX : e.clientX) - r.left - 6;
      var age = ((px - geo.m.l) / geo.pw) * AGE_MAX;
      if (age < 0 || age > AGE_MAX) return hideTip();
      hoverAge = age;
      var qy = qol(age, shown.L, shown.n), qa = qol(age, BASE.L, BASE.n);
      tip.innerHTML =
        '<div class="hsx-tip-age">Age ' + Math.round(age) + '</div>' +
        '<div class="hsx-tip-row"><span class="hsx-dot" style="background:' + C_YOU + '"></span>You<b>' + Math.round(qy * 100) + '%</b></div>' +
        '<div class="hsx-tip-row"><span class="hsx-dot" style="background:' + C_AVG + '"></span>Average<b>' + Math.round(qa * 100) + '%</b></div>';
      tip.className = 'hsx-tip is-on';
      tip.style.left = Math.max(64, Math.min(r.width - 64, geo.x(age) + 6)) + 'px';
      tip.style.top  = Math.max(60, geo.y(Math.max(qy, qa)) - 14) + 'px';
      draw();
    }
    function hideTip() {
      if (hoverAge === null) return;
      hoverAge = null; tip.className = 'hsx-tip'; draw();
    }
    wrap.addEventListener('mousemove', onMove);
    wrap.addEventListener('mouseleave', hideTip);
    wrap.addEventListener('touchmove', onMove, { passive:true });
    wrap.addEventListener('touchend', hideTip);

    if (window.ResizeObserver) new ResizeObserver(layout).observe(wrap);
    else window.addEventListener('resize', layout);

    layout();
    recompute();
  }

  function boot() {
    var nodes = document.querySelectorAll('.hsx-root');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__hsxDone) { nodes[i].__hsxDone = true; init(nodes[i]); }
    }
  }
  window.__hsxBoot = boot;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* theme editor: re-init when this section is re-rendered */
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
